var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 45,
    viewBox: "0 0 170 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 44.3628H169.815L133.034 37.6761C133.034 37.6761 138.235 23.5814 125.971 16.9748C113.707 10.3681 107.54 19.1774 107.54 19.1774C104.899 -4.60789 74.9469 -4.1679 69.2215 12.5694C59.9709 2.43877 45.8762 12.2667 46.7576 22.4761C38.5349 21.5254 32.7722 29.4547 34.9189 34.4454C23.5602 39.4374 0.65625 44.3628 0.65625 44.3628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud2.42713a4bb27ad5e00b9707fa4277ec69.svg";
export { ForwardRef as ReactComponent };